import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';

import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import { green, orange } from '@material-ui/core/colors';

import Base13Icon from './../../Color graphic - no background.png';
import StreamLocatorLogo from './../../StreamLocator_logo.png';

import Header from './Header';
import Footer from './Footer';
import RequestDemo from './RequestDemo';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  button: {
    margin: theme.spacing(1),
  },
  divider: {
    margin: theme.spacing(3),
  },
  answer: {
    padding: theme.spacing(2, 0, 0),
  },
  image: {
    flex: 1,
    padding: 2,
    width: 100,
    height: 100,
    resizeMode: 'contain'
  },
  streamLocatorLogo: {
    width: '75vw',
    maxWidth: 200,
    paddingTop: 20,
    marginRight: 100,
    // height: 312,
  },
  paper: {
    width: 102,
    height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  paper: {
    padding: '6px 16px',
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
  logo: {
    width: 165,
    height: 48,
  },
  image: {
    flex: 1,
    padding: 2,
    width: 100,
    height: 100,
    resizeMode: 'contain'
  },
  paperLogo: {
    width: 102,
    height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
}));

export default function StreamLocatorCaseStudy() {
  const classes = useStyles();
  const bull = <span className={classes.bullet}>•</span>;

  return (
    <React.Fragment>
      <CssBaseline />
      <Header/>

      <Container maxWidth="md" component="main" className={classes.heroContent}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:10}}
        >
        </Box>
        <Typography component="h1" style={{padding:20}} variant="h2" align="center" color="textPrimary" gutterBottom>
          Ecommerce Case Study
        </Typography>

        <Card className={classes.cardCaseStudy} >
            <Box style={{padding:20}}>
            <CardContent>
              <Typography variant="h6" color="textPrimary" component="p" align="center" style={{paddingRight:0, paddingTop:20}}>
              Learn how this DTC brand took control of their data.
              </Typography>
              <Typography variant="h5" color="textSecondary" component="p" style={{paddingLeft:20, paddingTop:40, paddingRight:20}}>
                "FloSQL made it easy for us to combine all of our sources of data so we could build
                insights that drive the business.
                Our team was able to easily build out data pipelines on top of our data warehouse saving us time and money.
                Best of all we were able to increase our ROAS by leveraging their hosted Redash service."
              </Typography>
              <Typography variant="h5" color="textSecondary" component="p" align="right" style={{paddingRight:100, paddingTop:20}}>
                Jason Salzman, COO
              </Typography>
              <img align="right" className={classes.streamLocatorLogo} src={StreamLocatorLogo}/>
            </CardContent>
            </Box>
            <Box display="flex" style={{padding:20}}></Box>
        </Card>

      <Box display="flex" style={{padding:20}}></Box>

      <Grid container alignItems="flex-end" >
      <Grid xs={12} sm={12} md={12} lg={12} alignItems="flex-end">

      <Timeline align="alternate">
        <TimelineItem>
          <TimelineOppositeContent>
            <Typography variant="body2" color="textSecondary">

            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot style={{backgroundColor:'#e66771'}}>
              <Icon className="fas fa-exclamation-circle"/>
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" component="h1">
               Problem
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                StreamLocator was having trouble evaluating their marketing spend across multiple platforms.
                They knew they had to combine their data sources to effectively analyze it but they were moving fast and didn't want to hire up expensive data engineering capabilities.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                Having decided on leveraging a data warehouse and ETL tools they found the best way to build their data pipelines for the speed, efficiency, and accuracy they required was with FloSQL.
              </Typography>
              <Box style={{padding:5}}></Box>
            </Paper>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineOppositeContent>
            <Typography variant="body2" color="textSecondary">

            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot style={{backgroundColor:"#0284c7"}}>
              <Icon className="fas fa-link"/>
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" component="h1">
                Integrate
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                Integrating their Snowflake data warehouse with FloSQL took no time at all.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                This gave them the ability to start integrating all there data sources including Shopify, Facebook Ads, Google Ads, and Google Analytics.
              </Typography>
              <Box style={{padding:5}}></Box>
            </Paper>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineOppositeContent>
            <Typography variant="body2" color="textSecondary">

            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot style={{backgroundColor:"#0284c7"}}>
              <Icon className="fa fa-exchange-alt"/>
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" component="h1">
                Pipeline Design
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                With everything integrated they were ready to start building layers of data pipelines immediately.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                Setting up carefully crafted pipelines with FloSQL took only minutes.
              </Typography>
              <Box style={{padding:5}}></Box>
            </Paper>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot style={{backgroundColor:"#0284c7"}}>
              <Icon className="fa fa-cubes"/>
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" component="h1">
                Model Creation
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                Layering in SQL data models inside FloSQL was simple using the model editing suite.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                Automatically generated dependency mappings on SQL queries saved StreamLocator time and reduced data errors to ensure they had confidence in their data pipelines.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                To ensure any ongoing data quality issues aren't affecting the integrity of their important business decisions multiple validations were added and assigned to each model.
              </Typography>
              <Box style={{padding:5}}></Box>
            </Paper>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot style={{backgroundColor:"#0284c7"}}>
              <Icon className="fas fa-chart-line"/>
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" component="h1">
                Dashboards
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                Dashboards on Base13's hosted Redash service brought the data to life and saved thousands of dollars in overpriced solutions.
              </Typography>
              <Box style={{padding:5}}></Box>
            </Paper>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineOppositeContent>
            <Typography variant="body2" color="textSecondary">

            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot style={{backgroundColor:"#86C67C "}}>
              <Icon className="fas fa-check-circle"/>
            </TimelineDot>

          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" component="h1">
                Solution
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                In a matter of days instead of months StreamLocator was able derive insights that were previously unavailable.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                Using their new harmonized data strategy with FloSQL, StreamLocator was able to find insights they never thought previously possible and increase their ROAS.
              </Typography>
              <Box style={{padding:5}}></Box>
            </Paper>
          </TimelineContent>
        </TimelineItem>

      </Timeline>

      </Grid>
      </Grid>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:30}}
        >
        <Paper elevation={3} className={classes.paperLogo} >
          <img className={classes.image} src={Base13Icon} />
        </Paper>
      </Box>
      <Box style={{padding:10}}></Box>
      <Card className={classes.cardCaseStudy} >
          <Box style={{padding:10}}>
          <CardContent>
            <Typography align="center" variant="h5" color="textSecondary" component="p" style={{paddingLeft:20, paddingTop:20, paddingRight:20}}>
              At Base13 Labs we believe in the integrity of both our technology and in the relationships we build with our customers.
              Our goal is to provide our customers with unrivaled state-of-the-art data products to solve their ever evolving needs.
            </Typography>
            <Typography align="center" variant="h5" color="textSecondary" component="p" style={{paddingLeft:20, paddingTop:20, paddingRight:20}}>
              Start your FloSQL free trial today.
            </Typography>
          </CardContent>
          </Box>

          <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:10}}
        >
      <Box m="auto" className={classes.button}><Button size="large" href='/FreeTrial' variant="contained" style={{color: "white", backgroundColor:"#0284c7", borderColor:"#0284c7"}} >Try It Free</Button></Box>
          {/*<Box className={classes.button}><Button size="large" href='/RequestDemo' variant="outlined" style={{color:"#0284c7", borderColor:"#0284c7"}} >Request Demo</Button></Box>*/}
        </Box>
        <Box display="flex" style={{padding:10}}></Box>
      </Card>



      </Container>
      <Footer/>
    </React.Fragment>
  );
}